
import React, { Component } from 'react';
import { withRouter } from 'react-router-dom';
import { changeState, logout, mudarMensagens, mudarProcesso } from '../actions/AppActions';
import { connect } from 'react-redux';

import SweetAlert from 'react-bootstrap-sweetalert';
import { decrypt, URL } from '../variables';
import Chat from './Chat';
import axios from 'axios';
import { Buffer } from 'buffer';
import { formatDuration, ServerClock } from './serverClock';
import { getLanguageTexts, getSelectedLanguage } from '../language';
import { CandidateValidationNotice } from './CandidateUi';

class AceiteRegras extends Component {

    constructor(props) {
        super(props);
        this.state = {
            menu: false,
            redirect: false,
            path: '/',

            show_warning: false,
            loading_aceite: false,
            show_error: false,
            show_aceite: false
        };
        this.canvas = React.createRef();
        this.videoRef = React.createRef();
        this.time_text = '88:88:88';
        this.unmont_ = false;

        this.serverClock = new ServerClock();
    }

    incTimer() {
        const t = getLanguageTexts(getSelectedLanguage());

        if (!this.serverClock.isReady()) {

            this.timer_timeout = setTimeout(
                () => this.incTimer(),
                1000
            );

            return;
        }

        const totalSecs = this.serverClock.secondsUntil(this.props.processo.fim);
        const formattedTime = formatDuration(totalSecs);

        if (document.getElementById('timer') == null) {
            return;
        }

        if (totalSecs <= 0) {

            this.time_text = "00:00:00";

            document.getElementById('timer').innerHTML =
                `${t.remaining_time}: 00:00:00`;

            this.props.get_processo();

            return;
        }

        this.time_text = formattedTime;

        document.getElementById('timer').innerHTML =
            `${t.remaining_time}: ${formattedTime}`;

        this.timer_timeout = setTimeout(
            () => this.incTimer(),
            1000
        );
    }

    componentDidUpdate(props) {
        if (this.props.tempo_atual != null && this.props.tempo_atual != props.tempo_atual) {
            this.serverClock.sync(this.props.tempo_atual);
        }
    }

    componentDidMount() {
        this.props.changeState({ candidate_stage: 'rules' });
        this.serverClock.sync(this.props.tempo_atual);
        if (this.props.processo.type_fiscalization == 'all' || this.props.processo.type_fiscalization == 'image') {
            if (this.videoRef.current != null) {
                this.videoRef.current.srcObject = this.props.stream;
            }
        }

        this.incTimer();
        if (this.props.processo.simulado == false) {
            this.logs_timeout = setTimeout(() => {
                this.salvar_log();
            }, this.props.processo.save_timer_pre_exam);
            if (this.props.socket != null && this.props.user.accessibility && this.props.user.type_supervisor != 'none' && this.props.processo.is_interview == false) {
                console.log('montou', this.props.user)
                this.props.changeState({ show_call: true });
            }
        }
        else {
            this.lineCheckInterval = setInterval(() => {
                if (this.props.socket != null) {
                    this.props.socket.emit("line_check", { aluno_id: this.props.user.id, faculdade_id: this.props.faculdade.id, enter_now: true });
                }
            }, 30000);
        }

        this.timer_get_time = setTimeout(() => {
            this.get_time_server();
        }, 30000);
    }




    salvar_aceite(foto) {
        fetch(`${URL}api/aceitar_termos?v=a`, {
            method: 'POST',
            headers: {
                'Accept': 'application/json',
                'Authorization': `Bearer ${this.props.token}`,
                'Content-Type': 'application/json',
                'X-Requested-With': 'XMLHttpRequest'
            },
            body: JSON.stringify({
                processo_id: this.props.processo.id
            })
        }).then(async (responseLog) => {
            try {
                let resp = await responseLog.json();
                resp = decrypt(resp);
                console.log(resp);
                if (resp.message == "Unauthenticated.") {
                    localStorage.removeItem('token');
                    // this.setState({redirect:true,path:'/'});
                    this.props.logout();
                }
                else if (resp.message == "Server Error") {
                    this.timeout_aceitar_regras = setTimeout(() => {
                        this.aceitar_regras(foto, true);
                    }, 5000);
                }
                else if (resp.errors != null || resp.error != null) {
                    let errors = Object.values(resp.errors);
                    let erro = '';
                    for (let i = 0; i < errors.length; i++) {
                        if (i != errors.length - 1)
                            erro += errors[i] + '\n';
                        else
                            erro += errors[i];
                    }
                    console.log(erro);
                    this.setState({ loading_aceite: false, show_error: true });

                    //   setTimeout(()=>{
                    //     this.get_processo();
                    //   });
                }
                else {
                    this.props.aceitar_regras(resp);
                }




            } catch (err) {
                // this.setState({ loading_aceite: true, show_error: true });
                this.timeout_aceitar_regras = setTimeout(() => {
                    this.aceitar_regras(foto, true);
                }, 5000);
                console.log(err);
            }

        })
            .catch((err) => {
                // this.setState({ loading_aceite: true, show_error: true });
                this.timeout_aceitar_regras = setTimeout(() => {
                    this.aceitar_regras(foto, true);
                }, 5000);
                console.log(err);
                // this.props.mudarLoadingHome(false);
            });
    }

    aceitar_regras(foto, file_saved = false) {
        if (this.unmont_ == true) {
            return;
        }
        console.log(this.props.processo_resultado);
        this.setState({ loading_aceite: true, show_warning: false });
        if ((this.props.processo.type_fiscalization == 'all' || this.props.processo.type_fiscalization == 'image') && foto != null) {
            if (file_saved == true) {
                this.salvar_aceite(foto);
            }
            else if (this.props.processo_resultado.url_upload_photo != undefined) {
                const type = foto.split(';')[0].split('/')[1]
                const buffer = Buffer.from(foto.replace(/^data:image\/\w+;base64,/, ""), 'base64');

                console.log(buffer);
                axios.put(this.props.processo_resultado.url_upload_photo, buffer, {
                    headers: {
                        "Content-Type": type
                    }
                }).then((resp) => {
                    console.log(resp)
                    this.salvar_aceite(foto);


                }).catch((error) => {
                    console.log(error);
                    //link expirou provavelmente
                    let error_string = 'error';
                    if (typeof error === 'string' || error instanceof String)
                        error_string = error;
                    else if (error) {
                        error_string = JSON.stringify(error)
                    }
                    this.salvar_log('error', error_string)
                    if (error.response) {
                        this.props.get_processo();
                    }
                    else {
                        this.timeout_aceitar_regras = setTimeout(() => {
                            this.aceitar_regras(foto);
                        }, 5000);
                    }

                });
            }
            else {
                this.props.get_processo();
                return;
            }
        }
        else {
            axios.put(this.props.processo_resultado.url_upload_photo, 'teste', {
                headers: {
                    "Content-Type": 'image/jpeg'
                }
            }).then((resp) => {
                console.log(resp)
                this.salvar_aceite(null);
            }).catch((error) => {
                console.log(error);
                //link expirou provavelmente
                let error_string = 'error';
                if (typeof error === 'string' || error instanceof String)
                    error_string = error;
                else if (error) {
                    error_string = JSON.stringify(error)
                }
                this.salvar_log('error', error_string)
                if (error.response) {
                    this.props.get_processo();
                }
                else {
                    this.timeout_aceitar_regras = setTimeout(() => {
                        this.aceitar_regras(null);
                    }, 5000);
                }

            });
            // this.salvar_aceite(null);
        }


    }

    componentWillUnmount() {
        clearTimeout(this.timeout_aceitar_regras);
        clearTimeout(this.logs_timeout);
        clearTimeout(this.timer_timeout);
        this.unmont_ = true;
        clearTimeout(this.timer_get_time);
        clearInterval(this.lineCheckInterval);
    }

    salvar_log(error = 'aceite', msg = '') {
        fetch(`${URL}api/salvar_log?v=a&screen=${error}&processo_id=${this.props.processo.id}&processo_name=${this.props.processo.name}&msg=${msg}`, {
            method: 'GET',
            headers: {
                Accept: 'application/json',

                'Authorization': `Bearer ${this.props.token}`,
                // 'Content-Type': 'application/json',
            }
        }).then(async (responseLog) => {
            try {
                let resp = await responseLog.json();
                resp = decrypt(resp);
                console.log(resp);
                if (resp.message == "Unauthenticated.") {
                    localStorage.removeItem('token');
                    // this.setState({redirect:true,path:'/'});
                    this.props.logout();
                }
                else {
                    this.serverClock.sync(resp.atual);
                    if (resp.status == false) {
                        this.props.get_processo();
                    }
                    else {
                        if (resp.processo != null && resp.processo.updated_at != this.props.processo.updated_at) {
                            this.props.mudarProcesso(resp.processo);
                        }
                        if (resp.atual != null) {
                            this.serverClock.sync(resp.atual);
                        }
                        if (this.unmont_ == false && this.props.processo.simulado == false && error == 'aceite') {
                            this.logs_timeout = setTimeout(() => {
                                this.salvar_log();
                            }, this.props.processo.save_timer_pre_exam);
                        }
                    }
                }
            } catch (err) {
                console.log(err);
                if (this.unmont_ == false && this.props.processo.simulado == false && error == 'aceite') {

                    this.logs_timeout = setTimeout(() => {
                        this.salvar_log();
                    }, this.props.processo.save_timer_pre_exam);
                }
            }

        })
            .catch((err) => {
                console.log(err);
                if (this.unmont_ == false && this.props.processo.simulado == false && error == 'aceite') {

                    this.logs_timeout = setTimeout(() => {
                        this.salvar_log();
                    }, this.props.processo.save_timer_pre_exam);
                }
            });
    }

    uuidv4() {
        return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
            var r = Math.random() * 16 | 0, v = c == 'x' ? r : (r & 0x3 | 0x8);
            return v.toString(16);
        });
    }



    get_time_server() {

        fetch(`${URL}api/get_time_server?v=a`, {
            method: 'GET',
            headers: {
                Accept: 'application/json',

                'Authorization': `Bearer ${this.props.token}`,
                // 'Content-Type': 'application/json',
            }
        }).then(async (responseLog) => {
            try {
                let resp = await responseLog.json();
                console.log(resp);
                if (resp.message == "Unauthenticated.") {
                    localStorage.removeItem('token');
                    // this.setState({redirect:true,path:'/'});
                    this.props.logout();
                    return;
                }
                else {
                    if (resp.atual != null) {
                        this.serverClock.sync(resp.atual);
                    }
                }
                this.timer_get_time = setTimeout(() => {
                    this.get_time_server();
                }, 30000);
            } catch (err) {
                console.log(err);
                this.timer_get_time = setTimeout(() => {
                    this.get_time_server();
                }, 30000);
            }

        })
            .catch((err) => {
                console.log(err);
                this.timer_get_time = setTimeout(() => {
                    this.get_time_server();
                }, 30000);
            });
    }




    render() {
        const t = getLanguageTexts(getSelectedLanguage());

        return (
            <div className="candidate-state candidate-rules">
                {/* {<div  style={this.props.processo.type_fiscalization == 'none'?{bottom:0,right:0,top:'unset'}:{}} id='timer'
                    className='timer_exam'>

                </div>} */}
                <hr />
                <p className="candidate-section-kicker">{t.before_start}</p>
                <h3 className="candidate-section-title">
                    {t.read_accept_rules_title}
                </h3>
                <p className="candidate-section-description">{t.read_accept_rules_description}</p>
                <p className="m-b-20 candidate-rules-label">
                    <b>{t.evaluation_rules}</b>
                </p>
                <div className="jodit-wysiwyg candidate-rules-content" dangerouslySetInnerHTML={{ __html: this.props.processo.regras }}>
                </div>


                <video ref={this.videoRef} muted autoPlay id="background-canvas" style={{ height: '100px', position: 'absolute', top: 200, zIndex: -1 }}></video>

                <hr />


                {this.props.connect == false && this.props.socket != null && <CandidateValidationNotice tone="warning" title={t.unstable_connection}>{t.unstable_connection}</CandidateValidationNotice>}

                {this.state.loading_aceite == false && <div className="row">
                    <div className="col-12">
                        <button type="button" id="accept" onClick={this.onAceite.bind(this)} className="btn btn-primary btn-lg waves-effect waves-light candidate-primary-action"
                            style={{ width: '100%' }}><i className="mdi mdi-shield-check-outline"></i> {t.accept_evaluation_rules}</button>
                    </div>
                </div>}
                {this.state.loading_aceite == true && <div className="row"> <div className="col-12 d-flex justify-content-center align-items-center" style={{ marginTop: '2rem' }}>
                    <div className="spinner-border text-primary" role="status"  >
                        <span className="sr-only">{t.loading_accessibility}</span>
                    </div>
                </div></div>}
                <canvas ref={this.canvas} id="background-canvas"     style={{ display: 'none' }}
></canvas>
                {this.props.processo.simulado == false && this.props.processo_resultado?.status != 'F' && (this.props.processo.type_fiscalization == 'all' || this.props.processo.type_fiscalization == 'image') && this.props.processo.chat_type != 'none' && <Chat
                    send_message={(m) => this.props.send_message(m)}
                />}

                <SweetAlert
                    warning
                    title={t.attention}
                    onConfirm={this.onConfirm.bind(this)}
                    onCancel={this.onCancel.bind(this)}
                    show={this.state.show_warning}
                    confirmBtnText={t.accept_button}
                    cancelBtnText={t.cancel}
                    confirmBtnBsStyle="success"
                    cancelBtnBsStyle="danger"
                    showCancel={true}
                >
                    {t.accepting_rules_takes_photo}

                </SweetAlert>
                <SweetAlert
                    danger
                    title={t.error_title}
                    onConfirm={() => this.setState({ show_error: false })}
                    // onCancel={this.onCancel.bind(this)}
                    show={this.state.show_error}
                    confirmBtnText={t.ok}
                    cancelBtnText={t.cancel}
                    confirmBtnBsStyle="info"
                    // cancelBtnBsStyle="success"
                    showCancel={false}
                >
                    {t.generic_error}
                </SweetAlert>

            </div>

        );
    }

    onConfirm() {
        this.setState({ show_warning: false });
        this.canvas.current.height = this.videoRef.current.videoHeight;
        this.canvas.current.width = this.videoRef.current.videoWidth;
        this.canvas.current.getContext('2d').drawImage(this.videoRef.current, 0, 0);
        // console.log(this.canvas.current.toDataURL('image/jpeg'))
        // return;
        if (this.props.processo.show_document && this.props.validation_photo != null) {
            this.aceitar_regras(this.props.validation_photo);
        }
        else {
            this.aceitar_regras(this.canvas.current.toDataURL('image/jpeg', 0.15));
        }
    }

    onCancel() {
        this.setState({ show_warning: false });
    }

    onAceite() {
        if (this.props.processo.type_fiscalization == 'all' || this.props.processo.type_fiscalization == 'image') {
            this.setState({ show_warning: true });
        }
        else {
            this.aceitar_regras(null);
        }
    }
}
const mapsStateToProps = (state) => (
    {
        tempo_atual: state.AppReducer.tempo_atual,
        processo: state.AppReducer.processo,
        faculdade: state.AppReducer.faculdade,
        stream: state.AppReducer.stream,
        token: state.AppReducer.token,
        processo_resultado: state.AppReducer.processo_resultado,
        connect: state.AppReducer.connect,
        socket: state.AppReducer.socket,
        mensagens: state.AppReducer.mensagens,
        user: state.AppReducer.user,
        sala: state.AppReducer.sala,
        candidate_inside_screen: state.AppReducer.candidate_inside_screen,

    }
);

export default withRouter(connect(mapsStateToProps, { logout, mudarProcesso, mudarMensagens, changeState })(AceiteRegras));
